// extracted by mini-css-extract-plugin
export default {"addContainer":"add2_addContainer__BDist","icon":"add2_icon__9U90t","text":"add2_text__Mpx04"};